import React from 'react';
import { Tabs } from 'antd';
import { MessageOutlined, UserOutlined, AppstoreOutlined, SmileOutlined, RobotOutlined } from '@ant-design/icons';
import GroupAutoReplies from './GroupAutoReplies';
import PrivateReplyTemplates from './PrivateReplyTemplates';
import WelcomeTemplates from './WelcomeTemplates';
import BotJoinMessage from './BotJoinMessage';
import KeyboardButtons from './KeyboardButtons';

const { TabPane } = Tabs;

/**
 * 自动回复管理总览页面
 * 统一入口，包含四个子页面：
 * 1. 群组自动回复
 * 2. 私聊回复模板
 * 3. 入群欢迎语
 * 4. 入群自我介绍
 * 5. 键盘按钮设置
 */
const AutoRepliesManagement: React.FC = () => {
  return (
    <div style={{ padding: '0 24px' }}>
      <Tabs defaultActiveKey="1" size="large">
        <TabPane
          tab={
            <span>
              <MessageOutlined />
              群组/频道自动回复
            </span>
          }
          key="1"
        >
          <GroupAutoReplies />
        </TabPane>

        <TabPane
          tab={
            <span>
              <UserOutlined />
              私聊回复模板
            </span>
          }
          key="2"
        >
          <PrivateReplyTemplates />
        </TabPane>

        <TabPane
          tab={
            <span>
              <SmileOutlined />
              入群欢迎语
            </span>
          }
          key="3"
        >
          <WelcomeTemplates />
        </TabPane>

        <TabPane
          tab={
            <span>
              <RobotOutlined />
              入群自我介绍
            </span>
          }
          key="4"
        >
          <BotJoinMessage />
        </TabPane>

        <TabPane
          tab={
            <span>
              <AppstoreOutlined />
              键盘按钮设置
            </span>
          }
          key="5"
        >
          <KeyboardButtons />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default AutoRepliesManagement;
